<template>
  <div>
    <div class="d-flex flex-wrap justify-space-between mb-4">
      <h2 class="mb-4">Zoom Setting</h2>
      <v-btn color="primary" v-if="entity.id" @click="dialogUnlinkVerification = true">Unlink Zoom Account</v-btn>
      <v-btn color="primary" v-else @click="dialogLinkVerification = true">Link Zoom Account</v-btn>
    </div>
    <div>
      <v-card>
        <v-card-title class="headline"> Zoom User Details </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col> Zoom Email </v-col>
              <v-col>
                {{ entity.zoomEmail }}
              </v-col>
            </v-row>
            <v-row>
              <v-col> Verification Code </v-col>
              <v-col>
                {{ entity.code }}
              </v-col>
            </v-row>
            <v-row>
              <v-col> Expired </v-col>
              <v-col>
                {{
                  entity.refreshExpired
                    ? entity.refreshExpired.date.year +
                      "-" +
                      entity.refreshExpired.date.month +
                      "-" +
                      entity.refreshExpired.date.day +
                      " " +
                      ("0" + entity.refreshExpired.time.hour).slice(-2) +
                      ":" +
                      ("0" + entity.refreshExpired.time.minute).slice(-2) +
                      ":" +
                      ("0" + entity.refreshExpired.time.second).slice(-2)
                    : ""
                }}
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="dialogLinkVerification" max-width="500">
      <v-card>
        <v-card-title>Confirm Zoom Authorization</v-card-title>
        <v-card-text>
          <p>You're about to verify zoom account, you will be redirected to zoom authorization page once prompted.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLinkVerification = false">Cancel</v-btn>
          <v-btn color="primary" @click="requestZoomAuthorization()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogUnlinkVerification" max-width="500">
      <v-card>
        <v-card-title>Confirm Unlink Account</v-card-title>
        <v-card-text>
          <p>You're about to unlink zoom account access to v-unite</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogUnlinkVerification = false">Cancel</v-btn>
          <v-btn color="primary" @click="revokeAccess()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmAuthorize" max-width="500">
      <v-card>
        <v-card-title>Account Verified!</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              dialogConfirmAuthorize = false;
              $router.push('/tenant/zoomSettings');
            "
            >Done</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["experienceId"],
  data() {
    return {
      dialogConfirmAuthorize: false,
      dialogLinkVerification: false,
      dialogUnlinkVerification: false,
      code: null,
      entity: {}
    };
  },
  mounted() {
    this.getZoomClientId();
    if (this.$route.path.includes("/authorize") && this.$route.query && this.$route.query.code) {
      this.verifyZoomAccount(this.$route.query.code);
    } else {
      this.loadAuthentication();
    }
  },
  methods: {
    getZoomClientId() {
      axios
        .get("/system/zoomsettings/oauth/client")
        .then((response) => {
          this.zoomClientId = response.data;
        })
        .catch(() => {});
    },
    loadAuthentication() {
      axios.get("/system/zoomsettings/get").then((response) => {
        if (response.data != null) {
          this.entity = response.data;
        }
      });
    },
    requestZoomAuthorization() {
      window.location.href = "https://zoom.us/oauth/authorize?client_id=" + this.zoomClientId + "&response_type=code&redirect_uri=" + this.getRedirectUri();
    },
    verifyZoomAccount(code) {
      axios.post("/system/zoomsettings/oauth/token", { code: code }).then(() => {
        axios.get("/system/zoomsettings/oauth/verify").then((response) => {
          if (response.data != null) {
            this.entity = response.data;
          } else {
            this.entity = {};
          }
          this.dialogConfirmAuthorize = true;
        });
      });
    },
    revokeAccess() {
      axios.post("/system/zoomsettings/oauth/revoke").then(() => {
        this.entity = {};
        this.dialogUnlinkVerification = false;
        alert("Account access revoked");
      });
    },
    getRedirectUri() {
      let url = window.location.origin.toString().replaceAll("/", "%2F").replaceAll(":", "%3A");
      return url + "%2F%23%2Ftenant%2FzoomSettings%2Fauthorize%2F";
    }
  }
};
</script>